import type { SimulationConfig, SimulationSnapshot } from './types';
import { hydrateSnapshot } from './transport';

export class SimulationClient {
  private cancel: (() => void) | null = null;

  run(config: SimulationConfig): Promise<SimulationSnapshot> {
    this.cancel?.();
    return new Promise((resolve, reject) => {
      const worker = new Worker(new URL('./simulation.worker.ts', import.meta.url), { type: 'module' });
      const finish = () => { worker.terminate(); this.cancel = null; };
      this.cancel = () => { finish(); reject(new DOMException('Replaced by a newer configuration', 'AbortError')); };
      worker.onmessage = (event: MessageEvent<{ snapshot?: SimulationSnapshot; error?: string }>) => {
        finish();
        if (event.data.snapshot) {
          try { resolve(hydrateSnapshot(event.data.snapshot)); } catch (error) { reject(error); }
        } else reject(new Error(event.data.error ?? 'Respuesta de simulación inválida'));
      };
      worker.onerror = (event) => { finish(); reject(new Error(event.message || 'No se pudo iniciar el cálculo')); };
      worker.onmessageerror = () => { finish(); reject(new Error('No se pudo recibir el resultado')); };
      try { worker.postMessage(config); } catch (error) { finish(); reject(error); }
    });
  }
}
